import { useState } from "react";

// Keep a tab's selection across route unmounts without sharing it across browser tabs.
export function useSessionSelection<T extends string>(key: string, options: readonly T[], fallback: T | undefined) {
  const [stored, setStored] = useState<string | null>(() => {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  });
  const selected = options.find((option) => option === stored) ?? fallback;
  const select = (value: T) => {
    setStored(value);
    try {
      sessionStorage.setItem(key, value);
    } catch {
      // Selection still works for this mount when browser storage is unavailable.
    }
  };
  return [selected, select] as const;
}
